module.exports = __webpack_public_path__ + "img/America.1edbf5db.png";